import { Flex, Typography } from "antd"

export const TransactionHistoryStepUi = () => {
  return (
    <>
      <Typography.Text>
        In this section, you can view your transaction history, categorized into
        the following sections:
      </Typography.Text>

      <ul>
        <li>IN – All incoming payments.</li>
        <li>OUT – Bulk cryptocurrency payouts.</li>
        <li>
          SWAP – Conversion transactions made through the Convert feature.
        </li>
        <li>
          DEPOSIT – Incoming transactions processed via API Deposit integration.
        </li>
        <li>
          ON-RAMP WIDGET – Transactions from the Cryptix widget, allowing users
          to buy crypto with Visa/Mastercard.
        </li>
      </ul>

      <Typography.Text>
        For incoming transactions, you can manually initiate a refund by
        clicking the Refund button.
      </Typography.Text>
    </>
  )
}
